"use strict";

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ellipseString = ellipseString;
exports.formatPhoneNumber = formatPhoneNumber;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PHONE_NUMBER_RE = /\+1(\d{3})(\d{3})(\d{4})/;

function ellipseString() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 180;
  var endString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';
  return string.length > limit ? "".concat(string.slice(0, limit)).concat(endString) : string;
}

function formatPhoneNumber(phoneNumber) {
  if (!PHONE_NUMBER_RE.test(phoneNumber)) {
    throw new Error('Improperly formatted phone number given');
  }

  var _phoneNumber$match$sl = phoneNumber.match(PHONE_NUMBER_RE).slice(1, 4),
      _phoneNumber$match$sl2 = _slicedToArray(_phoneNumber$match$sl, 3),
      areaCode = _phoneNumber$match$sl2[0],
      firstThree = _phoneNumber$match$sl2[1],
      lastFour = _phoneNumber$match$sl2[2];

  return "(".concat(areaCode, ") ").concat(firstThree, "-").concat(lastFour);
}